import CameraControls from "https://cdn.jsdelivr.net/npm/camera-controls@2.8.3/dist/camera-controls.module.min.js";
import { FBXLoader } from "https://unpkg.com/three@0.149.0/examples/jsm/loaders/FBXLoader.js";
import * as THREE from "three";
CameraControls.install({ THREE: THREE });

const canvasEl = document.querySelector("#globe-3d");
const containerEl = document.querySelector(".globe-wrapper");

let renderer, scene, camera, controls, rayCaster, pointer;
let globeGroup, globeModel;

// Paramètres pour le placement des images des fruits sur le globe
const params = {
	imagePinSize: 0.15,
	imagePinTranslateY: 0.15,
	imagePinTranslateZ: 0.13,
	imagePinRotateX: -15,
};

// Paramètres pour la rotation du globe pour le débogage
const debugParams = {
	rotationX: 0,
	rotationY: 0,
	rotationZ: 0,
};

let userDragging = false;
let disableAutoRotate = false;

const sizes = {
	width: window.innerWidth,
	height: window.innerHeight,
};

let isTouchScreen = false;
let isHoverable = true;

const textureLoader = new THREE.TextureLoader();
const fbxLoader = new FBXLoader();

const clock = new THREE.Clock();

// Fonction pour récupérer les données des fruits
const fetchFruits = () => {
	var json = JSON.parse(document.querySelector("#mm-hero-banner-container").dataset.json);
	return json;
};
const fruits = [];

initScene();

function initScene() {
	// Initialisation du rendu, de la scène et de la caméra
	renderer = new THREE.WebGLRenderer({ canvas: canvasEl, alpha: true, antialias: true });

	renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

	scene = new THREE.Scene();

	camera = new THREE.OrthographicCamera(-1.7, 1.7, 1.7, -1.7, 0, 5);
	camera.position.z = 1.5;

	globeGroup = new THREE.Group();
	scene.add(globeGroup);

	rayCaster = new THREE.Raycaster();
	rayCaster.far = 1.15;
	pointer = new THREE.Vector2(-1, -1);

	createOrbitControls();
	createGlobe();
	createLights();
	updateSize();
	render();
}

// Calcul des coordonnées à partir de la latitude et de la longitude
function calcPosFromLatLngRad(lat, lng) {
	const phi = lat * (Math.PI / 180);
	const theta = (lng + 180) * (Math.PI / 180);
	let x = -(Math.cos(phi) * Math.cos(theta));
	let z = Math.cos(phi) * Math.sin(theta);
	let y = Math.sin(phi);

	return { x, y, z };
}

// Creation du globe
async function createGlobe() {
	// Chargement du globe
	fbxLoader.load("https://cdn.shopify.com/s/files/1/0684/1696/2804/files/globe.fbx?v=1713861039", (globe) => {
		globe.scale.set(1, 1, 1);
		globe.rotation.y = Math.PI;
		globeGroup.add(globe);
	});

	// Supposons que fetchFruits est une fonction qui récupère vos données de fruits
	const data = fetchFruits(); // Assurez-vous que cette fonction est bien définie et renvoie les données attendues

	data.fruits.forEach((fruit, index) => {
		fruits.push(fruit); // Ajoute chaque fruit au tableau pour un accès ultérieur
		let coords = calcPosFromLatLngRad(fruit.coords.lat, fruit.coords.lng);
		addPin(coords, fruit.image, fruit, index);
	});
}

// Ajout des pins
async function addPin(coords, imageUrl, fruitInfo, index) {
	fbxLoader.load("https://cdn.shopify.com/s/files/1/0684/1696/2804/files/pins_1.fbx?v=1714142106", (pin) => {
		const position = new THREE.Vector3(coords.x, coords.y, coords.z);
		pin.position.copy(position);
		pin.scale.set(0.6, 0.6, 0.6);

		pin.lookAt(new THREE.Vector3(0, Math.PI, 0)); // Oriente le repère vers le centre du globe

		globeGroup.add(pin);

		// Assurez-vous que le raycaster puisse détecter ce pin
		pin.userData = {
			isPin: true,
			isSelected: index === 0, // true pour le premier pin, false pour les autres
			fruitInfo: { ...fruitInfo, index },
		};

		// Chargement et ajout de la texture de fruit
		const texture = textureLoader.load(imageUrl, (texture) => {
			texture.flipY = false;
			const placeholderCircle = new THREE.CircleGeometry(params.imagePinSize, 16);
			const imageMap = new THREE.CircleGeometry(params.imagePinSize, 16);

			// Utilisation de MeshStandardMaterial pour accéder à onBeforeCompile
			const material = new THREE.MeshStandardMaterial({
				map: texture,
				side: THREE.DoubleSide,
				color: 0xffffff,
				dithering: true,
				transparent: true, // Assurez-vous que la transparence est activée
			});
			const fruitColorMaterial = new THREE.MeshBasicMaterial({
				color: new THREE.Color(fruitInfo.color),
				side: THREE.DoubleSide,
			});

			const fruitPlaceholderMesh = new THREE.Mesh(placeholderCircle, fruitColorMaterial);
			const fruitImageMesh = new THREE.Mesh(imageMap, material);
			fruitImageMesh.scale.set(0.8, 0.8, 0.8);

			fruitPlaceholderMesh.position.y = params.imagePinTranslateY; // Ajustement de la rotation si nécessaire
			fruitPlaceholderMesh.position.z = params.imagePinTranslateZ + 0.01; // Ajustement de la rotation si nécessaire
			fruitPlaceholderMesh.rotation.x = params.imagePinRotateX; // Ajustement de la rotation si nécessaire

			fruitImageMesh.position.y = params.imagePinTranslateY; // Ajustement de la rotation si nécessaire
			fruitImageMesh.position.z = params.imagePinTranslateZ; // Ajustement de la rotation si nécessaire
			fruitImageMesh.rotation.x = params.imagePinRotateX; // Ajustement d

			pin.userData.isPin = true; // Ajoute une propriété personnalisée pour identifier les pins
			pin.add(fruitImageMesh, fruitPlaceholderMesh); // Ajoute l'image du fruit comme enfant du pin
		});

		// Si c'est le premier pin, appliquez immédiatement une animation de scale
		if (index === 0) {
			gsap.to(pin.scale, {
				x: 1.2, // Ou toute autre valeur de scale désirée
				y: 1.2,
				z: 1.2,
				duration: 1,
				ease: "power2.inOut",
			});
		}
	});
}

// Interaction with pins
canvasEl.addEventListener("click", (event) => {
	// Conversion des coordonnées du clic en coordonnées normalisées pour le raycasting
	const bounds = canvasEl.getBoundingClientRect(); // Obtient les dimensions du canvas et sa position relative à la zone d'affichage

	// Calcule les coordonnées normalisées de la souris par rapport à la position et taille du canvas
	pointer.x = ((event.clientX - bounds.left) / bounds.width) * 2 - 1;
	pointer.y = -((event.clientY - bounds.top) / bounds.height) * 2 + 1;

	// Effectuer le raycasting pour détecter les objets cliqués
	rayCaster.setFromCamera(pointer, camera);

	const intersects = rayCaster.intersectObjects(globeGroup.children, true);

	for (let i = 0; i < intersects.length; i++) {
		const object = intersects[i].object;

		// Utilise le parent si l'objet intersecté est marqué comme un pin
		if (object.parent && object.parent.userData.isPin) {
			// Extrait les informations du fruit associées au pin
			const fruitInfo = object.parent.userData;
			// Trouvez l'index du fruit cliqué
			const clickedFruitIndex = fruits.findIndex((fruit, index) => {
				return index === object.parent.userData.fruitInfo.index;
			});

			// Mettez à jour les cartes de produit avec le fruit cliqué et le fruit suivant
			rotateGlobeAndAnimateCards(clickedFruitIndex);

			break;
		}
	}
});

// Ajout des lights
function createLights() {
	// Création de lumières directionnelles
	const ambientLight = new THREE.AmbientLight(0xfdf2e8, 0.4);
	scene.add(ambientLight);

	const rightLight = new THREE.SpotLight(0xfdf2e8, 0.8);
	rightLight.position.set(30, -5, -25);
	camera.add(rightLight);

	const frontSoftLight = new THREE.SpotLight(0xfdf2e8, 0.1);
	frontSoftLight.position.set(0, 5, 70);
	camera.add(frontSoftLight);

	const leftLight = new THREE.SpotLight(0xf2a873, 1, 100, Math.PI, 1, 0.2);
	leftLight.position.set(-40, 5, 30);
	camera.add(leftLight);

	const leftHardLight = new THREE.SpotLight(0xf2a873, 0.5, 100, Math.PI / 3, 1, 0.2);
	leftHardLight.position.set(-20, -65, 70);
	camera.add(leftHardLight);

	const backLight = new THREE.SpotLight(0xf2a873, 0.5);
	backLight.position.set(0, 50, -10);
	camera.add(backLight);

	// N'oubliez pas d'ajouter la caméra à la scène après avoir attaché les lumières
	scene.add(camera);
}

// Création de l'orbit controle
function createOrbitControls() {
	// Configuration des contrôles de navigation
	controls = new CameraControls(camera, renderer.domElement);

	controls.mouseButtons.wheel = CameraControls.ACTION.NONE;
	controls.mouseButtons.right = CameraControls.ACTION.NONE;
	controls.mouseButtons.middle = CameraControls.ACTION.NONE;
	controls.mouseButtons.left = CameraControls.ACTION.ROTATE;

	controls.polarRotateSpeed = 0.01;
	controls.draggingSmoothTime = 0.26;
	controls.smoothTime = 0.3;

	const onRest = () => {
		controls.removeEventListener("rest", onRest);
		userDragging = false;
		disableAutoRotate = false;
	};

	controls.addEventListener("controlstart", () => {
		controls.removeEventListener("rest", onRest);
		userDragging = true;
		disableAutoRotate = true;
		gsap.to(globeGroup.scale, {
			duration: 0.3,
			x: 0.9,
			y: 0.9,
			z: 0.9,
			ease: "back(1.3).inOut",
		});
		gsap.to(globeGroup, {
			duration: 0.3,
			x: "-0.05",
			ease: "back(1.3).inOut",
		});
	});

	controls.addEventListener("controlend", () => {
		if (controls.active) {
			controls.addEventListener("rest", onRest);
			gsap.to(globeGroup.rotation, {
				duration: 0.6,
				x: "0",
				ease: "back(1.8).inOut",
			});
		} else {
			onRest();
		}
	});

	controls.addEventListener("transitionstart", () => {
		if (userDragging) return;

		disableAutoRotate = true;
		controls.addEventListener("rest", onRest);
	});

	// Écouter l'événement mouseup
	renderer.domElement.addEventListener("mouseup", function (event) {
		// Ajuster le scale du globe
		gsap.to(globeGroup.scale, {
			duration: 0.6,
			x: 1,
			y: 1,
			z: 1,
			ease: "back(1.8).inOut",
			onComplete: () => {
				isHoverable = true;
			},
		});
	});

	// Écouter l'événement mouseup
	renderer.domElement.addEventListener("mouseleave", function (event) {
		// Ajuster le scale du globe
		gsap.to(globeGroup.scale, {
			duration: 0.6,
			x: 1,
			y: 1,
			z: 1,
			ease: "back(1.8).inOut",
			onComplete: () => {
				isHoverable = true;
			},
		});
	});
}

//Fonction pour écouter l'état de survol de mes pins
function checkHover() {
	rayCaster.setFromCamera(pointer, camera);
	const intersects = rayCaster.intersectObjects(globeGroup.children, true);

	if (intersects.length > 0) {
		let intersectedGroup = null;

		// Recherche des objets intersectés pour trouver le groupe du pin
		for (let i = 0; i < intersects.length; i++) {
			const object = intersects[i].object;

			// Utilise le parent si l'objet intersecté est marqué comme un pin
			if (object.parent && object.parent.userData.isPin && !object.parent.userData.isSelected) {
				intersectedGroup = object.parent;
				break;
			}
		}

		// Si un groupe de pin est trouvé dans les intersections
		if (intersectedGroup) {
			// Animer l'échelle du pin survolé
			gsap.to(intersectedGroup.scale, {
				duration: 0.3,
				ease: "back(1.3).inOut",
				x: 0.72,
				y: 0.72,
				z: 0.72,
			});

			// Réinitialiser l'échelle des autres pins qui ne sont pas sélectionnés
			globeGroup.children.forEach((child) => {
				if (child.userData.isPin && child !== intersectedGroup && !child.userData.isSelected) {
					gsap.to(child.scale, {
						duration: 0.5,
						ease: "back(1.3).inOut",
						x: 0.6,
						y: 0.6,
						z: 0.6,
					});
				}
			});
		} else {
			// Aucune intersection trouvée, réinitialiser l'échelle de tous les pins non sélectionnés
			globeGroup.children.forEach((child) => {
				if (child.userData.isPin && !child.userData.isSelected) {
					gsap.to(child.scale, {
						duration: 0.3,
						ease: "back(1.3).inOut",
						x: 0.6,
						y: 0.6,
						z: 0.6,
					});
				}
			});
		}
	} else {
		// Aucune intersection trouvée, réinitialiser l'échelle de tous les pins non sélectionnés
		globeGroup.children.forEach((child) => {
			if (child.userData.isPin && !child.userData.isSelected) {
				gsap.to(child.scale, {
					duration: 0.3,
					ease: "back(1.3).inOut",
					x: 0.6,
					y: 0.6,
					z: 0.6,
				});
			}
		});
	}
}

window.addEventListener("mousemove", (event) => {
	const bounds = canvasEl.getBoundingClientRect(); // Obtient les dimensions du canvas et sa position relative à la zone d'affichage
	// Calcule les coordonnées normalisées de la souris par rapport à la position et taille du canvas
	pointer.x = ((event.clientX - bounds.left) / bounds.width) * 2 - 1;
	pointer.y = -((event.clientY - bounds.top) / bounds.height) * 2 + 1;
});

// Initialiser le rendu
var lastTime = 0; // Initialisez lastTime en dehors de la fonction render

function render(time) {
	const delta = clock.getDelta();
	const elapsed = clock.getElapsedTime();
	const updated = controls.update(delta);
	controls.disableAutoRotate = false;

	//Vérifier le survol uniquement si le globe est interactif
	if (isHoverable) {
		checkHover(); // Appel de la fonction de vérification du survol
	}

	// Gérer l'interaction tactile séparément si nécessaire
	if (isTouchScreen && isHoverable) {
		isHoverable = false;
	}

	if (!disableAutoRotate) {
		controls.azimuthAngle += 2 * delta * THREE.MathUtils.DEG2RAD;
	}

	// Rendu de la scène
	renderer.render(scene, camera);

	// Render ici Frame par Frame
	requestAnimationFrame(render);
}

// Interaction with cards
function rotateGlobe(fruit) {
	const latRad = (fruit.coords.lat * Math.PI) / 180;
	const lngRad = (fruit.coords.lng * Math.PI) / 180;

	// Convertir les coordonnées lat/long en vecteur directionnel
	// Note: Ceci est une simplification et peut nécessiter des ajustements basés sur votre modèle de globe
	const x = Math.cos(latRad) * Math.cos(lngRad);
	const z = Math.cos(latRad) * Math.sin(lngRad);

	const targetAngleY = Math.atan2(x, z);

	// Appliquer la rotation au globe pour aligner le fruit avec la direction de la caméra
	gsap.to(controls, {
		azimuthAngle: -targetAngleY,
		duration: 1.3,
		ease: "power4.inOut",
	});

	// Test update les controls et orientation camera
	controls.update();

	// Parcourir tous les pins pour mettre à jour leur état isSelected et appliquer des animations de scale
	globeGroup.children.forEach((child, index) => {
		if (child.userData.isPin) {
			if (child.userData.fruitInfo && child.userData.fruitInfo.index === currentFruitIndex) {
				// Marquer le pin comme sélectionné
				child.userData.isSelected = true;

				// Appliquer une animation de scale sur ce pin
				gsap.to(child.scale, {
					x: 1.1,
					y: 1.1,
					z: 1.1,
					duration: 1,
					ease: "power2.inOut",
				});
			} else {
				// Retirer le marqueur isSelected des autres pins
				child.userData.isSelected = false;

				// Réinitialiser le scale des autres pins
				gsap.to(child.scale, {
					x: 0.6,
					y: 0.6,
					z: 0.6,
					duration: 1,
					ease: "power2.inOut",
				});
			}
		}
	});
	setTimeout(() => {
		controls.disableAutoRotate = false; // Réactive l'autoRotate après 5 secondes
	}, 5000); // 5000 millisecondes équivalent à 5 secondes
}

// Sélection des éléments de carte nécessaires dans le HTML
let frontCard = document.querySelector(".front");
let backCard = document.querySelector(".behind");
const cards = document.querySelector(".cards");

let currentFruitIndex = 0; // Index initial du fruit affiché

// Modification des datas dans les cards produits
const updateCardContents = (card, fruit) => {
	//Title + Price
	var titleAndPriceContainer = card.querySelector(".mm-pc-product-title-price");
	if (titleAndPriceContainer) {
		if (fruit.unity != "") {
			var fruitUnity = `<div class="mm-pc-unity">${fruit.unity}&nbsp;</div>`;
		} else {
			var fruitUnity = "";
		}
		if (fruit.info_prix != "") {
			var fruitInfoPrix = `<div class="mm-pc-unity">·&nbsp;${fruit.info_prix}</div>`;
		} else {
			var fruitInfoPrix = "";
		}

		titleAndPriceContainer.innerHTML = `
        <div class="mm-text-large">${fruit.productName}</div>

				<div class="mm-pc-wrapper-price mm-flex">
					<div class="mm-pc-wrapper-unity mm-flex">
							${fruitUnity}

							${fruitInfoPrix}

					</div>
					<div class="mm-pc-price">
						${fruit.price}
					</div>
				</div>`;

		titleAndPriceContainer.setAttribute("href", fruit.url);
	}

	// variant_id
	card.querySelector(".mm-product-card").dataset.variantId = fruit.variant_id;

	// Bandeau
	var bandeau = card.querySelector(".mm-pc-bandeau");
	if (bandeau) {
		bandeau.innerText = fruit.bandeau;
		bandeau.style.display = fruit.bandeau ? "inline-block" : "none";
	}

	// Image
	const imgContainer = card.querySelector(".mm-pc-img-container");
	if (imgContainer) {
		if (fruit.color != null) {
			imgContainer.innerHTML = `
            <div class="mm-pc-bg-color mm-flex"><svg class="mm-pc-bg-svg" xmlns="http://www.w3.org/2000/svg" width="251" height="238" viewBox="0 0 251 238" fill="none"><path opacity="0.99" d="M251 119.59C251 184.31 204.163 230.166 125.5 236.776C46.8373 243.387 0 184.31 0 119.59C0 54.8702 49.2392 17.4281 125.5 2.4042C201.761 -12.6197 251 54.8702 251 119.59Z" fill="${fruit.color}" /></svg>
                <img src="${fruit.image}" alt="${fruit.productName}" srcset="${fruit.image}" width="300" height="207" loading="lazy" class="mm-pc-img">
            </div>`;
		} else {
			imgContainer.innerHTML = `
            <div class="mm-pc-bg-color mm-flex">
                <img src="${fruit.image}" alt="${fruit.productName}" srcset="${fruit.image}" width="300" height="207" loading="lazy" class="mm-pc-img">
            </div>`;
		}

		// Modifier l'attribut href de l'élément <a> parent
		imgContainer.setAttribute("href", fruit.url);
	}

	// Tag
	var tagsContainer = card.querySelector(".mm-pc-wrapper-tag");
	if (tagsContainer) {
		let city = fruit.city.replace("/", "'");
		if (city != "" && fruit.vertus != "") {
			tagsContainer.innerHTML = `<div class="mm-pc-localisation mm-pc-tag mm-flex">
              <span>${city}</span>
            </div>
            <div class="mm-pc-tag mm-flex">
              <span>${fruit.vertus}</span>
            </div>`;
		} else if (city != "" && fruit.vertus == "") {
			tagsContainer.innerHTML = `
            <div class="mm-pc-localisation mm-pc-tag mm-flex">
                <span>${city}</span>
            </div>
        `;
		} else if (city == "" && fruit.vertus != "") {
			tagsContainer.innerHTML = `
              <div class="mm-pc-tag mm-flex">
                  <span>${fruit.vertus}</span>
              </div>
          `;
		} else {
			// Si aucun des deux champs n'est renseigné
			tagsContainer.innerHTML = "";
		}
	}

	//CTA
	let cardLinks = card.querySelectorAll("a");
	console.log(cardLinks);

	cardLinks.forEach((link) => {
		link.href = fruit.url;
		console.log(link.href);
	});

	// var isInCartCTA = card.querySelector(".mm-qb-btn-text");
	// var isNotInCartCTA = card.querySelector(".mm-pc-cta-container");

	// if (fruit.is_in_cart) {
	//   if(isInCartCTA) {
	//     isInCartCTA.style.display = "flex"
	//     isNotInCartCTA.style.display = "none";
	//     var qttyInput = isInCartCTA.querySelector(".quantity__input");
	//     qttyInput.innerText = fruit.item_qtty;
	//   }
	// } else {
	//     if(isInCartCTA) {
	//       isNotInCartCTA.style.display = "flex";
	//       isInCartCTA.style.display = "none";
	//     }
	// }
};

const rotateGlobeAndAnimateCards = (direction) => {
	// Vérifier si directionOrIndex est un nombre (un index)
	if (typeof direction === "number") {
		// Utiliser directement l'index pour trouver le fruit correspondant
		currentFruitIndex = direction;
	} else {
		// Sinon, c'est une chaîne représentant la direction, donc calculer l'index basé sur cette direction
		switch (direction) {
			case "next":
				currentFruitIndex = (currentFruitIndex + 1) % fruits.length;
				break;
			case "prev":
				currentFruitIndex = (currentFruitIndex - 1 + fruits.length) % fruits.length;
				break;
			case "random":
				currentFruitIndex = Math.floor(Math.random() * fruits.length);
				break;
		}
	}

	const fruit = fruits[currentFruitIndex];
	rotateGlobe(fruit); // Oriente le globe vers le nouveau fruit
	let rotateFront = "15deg";
	let rotateBack = "-2deg";
	if (window.innerWidth < 768) {
		rotateFront = "30deg";
	}
	gsap.to(frontCard, {
		duration: 0.2,
		rotate: "15deg",
		ease: "power2.inOut",
		onComplete: () => {
			// Mise à jour des contenus des cartes
			updateCardContents(frontCard, fruit); // Carte de devant avec le fruit actuel
			gsap.to(frontCard, {
				scale: 1,
				rotate: "0deg",
				duration: 0.2,
				ease: "power2.inOut",
			});
		},
	});

	if (window.innerWidth < 768) {
		rotateBack = "-2deg";
	}
	gsap.to(backCard, {
		duration: 0.2,
		rotate: "-13deg",
		ease: "power2.inOut",
		onComplete: () => {
			// Mise à jour des contenus des cartes
			let nextFruitIndex = (currentFruitIndex + 1) % fruits.length;
			updateCardContents(backCard, fruits[nextFruitIndex]); // Carte arrière avec le prochain fruit

			gsap.to(backCard, {
				scale: 1,
				duration: 0.2,
				rotate: rotateBack,
				ease: "power2.inOut",
			});
		},
	});

	gsap.to([frontCard.querySelector("img"), backCard.querySelector("img")], {
		duration: 0.6,
		rotate: "0deg",
		opacity: 0,
		scale: 0.8,
		ease: "power2.inOut",
		onComplete: () => {
			// Mise à jour des contenus des cartes ici si nécessaire

			// Lancez une nouvelle animation pour réinitialiser la rotation et l'opacité
			gsap.to([frontCard.querySelector("img"), backCard.querySelector("img")], {
				duration: 0.6,
				rotate: "0deg",
				opacity: 1,
				scale: 1,
				ease: "power2.inOut",
			});
		},
	});
};

// Fonction pour ajouter temporairement la classe 'click'
function addTemporaryClass(element, className, duration) {
	element.classList.add(className);
	setTimeout(() => {
		element.classList.remove(className);
	}, duration);
}

// Fonction pour ajouter temporairement la classe 'click'
const addTemporaryClassToAllCircles = (className, duration) => {
	const circles = document.querySelectorAll(".globe-wrapper .canvas-container .globe-pattern .circle");
	circles.forEach((circle) => {
		addTemporaryClass(circle, className, duration);
	});
};

// Initialisation des écouteurs d'événements
document.getElementById("next").addEventListener("click", () => {
	rotateGlobeAndAnimateCards("next");
	controls.autoRotate = false;
	addTemporaryClassToAllCircles("click", 300);
});

document.getElementById("prev").addEventListener("click", () => {
	rotateGlobeAndAnimateCards("prev");
	controls.autoRotate = false;
	addTemporaryClassToAllCircles("click", 300);
});

document.getElementById("random").addEventListener("click", () => {
	rotateGlobeAndAnimateCards("random");
	controls.autoRotate = false;
	addTemporaryClassToAllCircles("click", 300);
});

// Gestion du clic sur la carte arrière
backCard.addEventListener("click", () => {
	rotateGlobeAndAnimateCards("next");
	addTemporaryClassToAllCircles("click", 300);
	controls.autoRotate = false;
});

// Ajoutez un gestionnaire d'événement de survol à la carte arrière
backCard.addEventListener("mouseenter", () => {
	// Appliquez une rotation sur le survol avec GSAP
	gsap.to(backCard, {
		rotate: "-7deg",
		duration: 0.2,
		ease: "power2.inOut",
	});
});

// Ajoutez un gestionnaire d'événement pour quand la souris quitte la carte
backCard.addEventListener("mouseleave", () => {
	// Revenez à la rotation originale avec GSAP
	gsap.to(backCard, {
		rotate: "-5deg", // Assurez-vous que cette valeur correspond à l'état de base de la carte après les animations
		duration: 0.2,
		ease: "power2.inOut",
	});
});

// Fonction appelée lorsque la carte de derrière est cliquée, pour déplacer la carte et tourner le globe
const moveCard = (card) => {
	// Ajout de la classe 'is-moving' à la carte de devant
	let frontCard = document.querySelector(".front");

	// Sélection d'un fruit aléatoire
	const randomFruit = fruits[Math.floor(Math.random() * fruits.length)];
	frontCard.classList.add("is-moving");

	// Après 1 seconde, enlève la carte de devant, ajoute les classes correspondantes pour la transition des cartes
	setTimeout(() => {
		frontCard.remove();
		card.classList.remove("behind");
		card.classList.add("front");

		// Création et ajout d'une nouvelle carte de derrière pour la prochaine transition
		const newBackCard = document.createElement("div");
		newBackCard.classList.add("card-product", "behind");
		newBackCard.innerHTML = `
            <div class="card">
                <img src="/${randomFruit.image}" alt="" width="100">
                <h3>${randomFruit.productName}</h3>
                <span class="origin">${randomFruit.city}</span>
            </div>
        `;

		// Ajout d'un écouteur d'événement de clic à la nouvelle carte de derrière
		cards.appendChild(newBackCard);
		newBackCard.addEventListener("click", () => moveCard(newBackCard, randomFruit)); // Passage de randomFruit ici
	}, 500);

	// Appel de la fonction pour tourner le globe vers le fruit sélectionné
	rotateGlobe(randomFruit);
};

// Ajout d'un écouteur d'événement de clic à la carte de derrière pour déclencher l'animation et la rotation du globe
backCard.addEventListener("click", () => {
	rotateGlobeAndAnimateCards();
});

// Gestionnaire de redimensionnement de la fenêtre
window.addEventListener("resize", updateSize);

function updateSize() {
	// Mise à jour de la taille de la fenêtre
	const windowHeight = window.innerHeight;
	const calculatedHeight = windowHeight - 33 - 42 - 39; // Soustraction de la hauteur du conteneur et des éléments ajoutés
	let minValue = 900;

	if (window.innerWidth < 1024) {
		minValue = 400;
	}

	const side = Math.min(minValue, calculatedHeight);
	// const side = Math.min(minValue, Math.min(window.innerWidth, window.innerHeight));

	// const side = Math.min(900, Math.min(window.innerWidth, window.innerHeight));
	containerEl.style.width = side + "px";
	containerEl.style.height = side + "px";
	renderer.setSize(side, side);
}
